import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.string.trim.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  class: "iframe-container"
};
var _hoisted_2 = {
  key: 0,
  class: "iframe-container__loading"
};
var _hoisted_3 = ["src"];
import { ref, onMounted, onBeforeUnmount, watchEffect, nextTick } from 'vue';
export default {
  __name: 'index',
  props: {
    src: {
      type: String,
      required: true
    }
  },
  emits: ['onload', 'previewFile'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    // 定义状态
    var isLoaded = ref(false);
    var loading = ref(true);
    var iframeRef = ref(null);
    var showLoading = function showLoading() {
      loading.value = true;
    };
    var hideLoading = function hideLoading() {
      loading.value = false;
    };

    // 重新加载 iframe 的方法
    var reloadIframe = function reloadIframe() {
      nextTick(function () {
        showLoading();
        isLoaded.value = false;
        if (iframeRef.value) {
          if (iframeRef.value.attachEvent) {
            iframeRef.value.attachEvent('onload', function () {
              isLoaded.value = true;
              hideLoading();
              emits('onload');
            });
          } else {
            iframeRef.value.onload = function () {
              return hideLoading();
            };
            emits('onload');
          }
        }
      });
    };

    // 监听窗口大小变化，重新加载 iframe
    var handleMessage = function handleMessage(msg) {
      // 检查消息来源和格式
      if (!msg || !msg.data) return;
      try {
        var ParseData;
        // 如果data是字符串，尝试解析
        if (typeof msg.data === 'string') {
          // 检查是否是空字符串或无效JSON
          if (!msg.data.trim()) return;
          ParseData = JSON.parse(msg.data);
        } else {
          // 如果data已经是对象，直接使用
          ParseData = msg.data;
        }

        // 检查是否有特定的标识来确认这是你需要的消息
        // 根据实际的消息格式来调整这个条件
        if (ParseData && (ParseData.type === 'previewFile' || ParseData.fileUrl || ParseData.fileName)) {
          console.log('解析后的数据:', ParseData);
          emits('previewFile', ParseData);
        } else {
          // 忽略不相关的消息
          console.log('收到非目标消息:', ParseData);
        }
      } catch (error) {
        console.error('解析message数据失败:', error);
        console.log('原始data:', msg.data);
      }
    };
    onMounted(function () {
      window.addEventListener('onload', reloadIframe);
      window.addEventListener('message', handleMessage);
    });
    onBeforeUnmount(function () {
      window.removeEventListener('onload', reloadIframe);
      window.removeEventListener('message', handleMessage);
    });

    // 监听 `isLoaded` 的变化，更新 `computedSrc`
    watchEffect(function () {
      if (!isLoaded.value) {
        reloadIframe();
      }
    });
    return function (_ctx, _cache) {
      var _component_Loading = _resolveComponent("Loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading), _cache[0] || (_cache[0] = _createElementVNode("span", null, "正在加载中...", -1))])) : _createCommentVNode("", true), _withDirectives(_createElementVNode("iframe", {
        ref_key: "iframeRef",
        ref: iframeRef,
        class: "iframe-container__iframe",
        src: props.src,
        frameborder: "0",
        allowfullscreen: ""
      }, null, 8, _hoisted_3), [[_vShow, !loading.value && !isLoaded.value]])]);
    };
  }
};